import React from 'react'
import {
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Nav,
  Row,
  Tab,
} from 'react-bootstrap'

import '../../../../pages/Dashboard/DashboardStyle.css'
import DashboardTable from '@components/pages/Dashboard/DashboardTable.component'
import { modalArAgingData } from '@components/pages/Dashboard/DashboardMockData'

type ARAgingModallProps = {
  title: string
  isOpen: boolean
  toggleModal: () => void
}

function ARAgingModal({
  title,
  isOpen,
  toggleModal,
}: ARAgingModallProps): React.ReactElement {
  const columns = [
    {
      field: 'guarantor',
      header: 'Guarantor',
      width: '100',
    },
    {
      field: 'phone',
      header: 'Phone',
      width: '50',
    },
    {
      field: '0-30',
      header: '0-30 Days',
      width: '50',
    },
    {
      field: '31-60',
      header: '31-60 Days',
      width: '50',
    },
    {
      field: '61-90',
      header: '61-90 Days',
      width: '50',
    },
    {
      field: '90plus',
      header: '90+ Days',
      width: '50',
    },
    {
      field: 'total',
      header: 'Total',
      width: '50',
    },
    {
      field: 'insurance',
      header: 'Insurance',
      width: '50',
    },
    {
      field: 'patient',
      header: 'Patient',
      width: '50',
    },
    {
      field: 'lastPatPayment',
      header: 'Last patient payment',
      width: '150',
    },
  ]
  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      className="modal-fullscreen ar-aging-modal"
    >
      <Modal.Header className="bg-custom3 rounded-top" closeButton>
        <Modal.Title className="text-white">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <Row>
          <Col md={12} className="chart-tab morning-huddle">
            <Tab.Container defaultActiveKey={'ar-aging'}>
              <Col md={12}>
                <Nav variant="pills" className="chart-tab">
                  <Nav.Item key={``} className="">
                    <Nav.Link eventKey={'ar-aging'}>{'AR Aging'}</Nav.Link>
                  </Nav.Item>
                  <Nav.Item key={``} className="">
                    <Nav.Link eventKey={'patiend-credit-bal'}>
                      {'Patient credit balances'}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col md={12} className="mt-3">
                <Tab.Content>
                  <Tab.Pane eventKey={'ar-aging'}>
                    <Row>
                      <Col md={3}>
                        <InputGroup className="mb-3">
                          <InputGroup.Text className="br-0">
                            <i className="bi bi-search"></i>
                          </InputGroup.Text>
                          <Form.Control placeholder="Search..." />
                        </InputGroup>
                      </Col>
                      <Col md={9} className="text-end">
                        <Button className="btn-ct btn btn-sm btn-light mt-2 custom-btn">
                          <i className="bi bi-filter me-1"></i>
                          Filter
                        </Button>
                      </Col>
                      <Col md={12}>
                        <DashboardTable
                          columns={columns}
                          data={modalArAgingData}
                          title={'AR Aging'}
                          allowMultiSorting={true}
                          allowSorting={true}
                          classNameTable="ar-aging-modal-tbl"
                          allowPaging={true}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey={'patiend-credit-bal'}>
                    <div>...</div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Tab.Container>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default ARAgingModal
